// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"133":"layout","353":"contact","461":"skills","594":"about","962":"home"}[chunkId] + "." + {"133":"1cd9fc0f","353":"82d84982","461":"f2adeac9","594":"d66b4242","962":"906908fb"}[chunkId] + ".js";
};